import React from "react";

const WhoCanJoin = ({ landingPageData }) => {
  return (
    <div className=" mx-auto lg:px-28 lg:mt-270 p-8">
      <div className="flex flex-col justify-center items-center">
        {/* heading */}
        <div>
          <h2 className="text-30 font-bold text-center">
            {landingPageData.whoCanJoin.title2}
          </h2>
        </div>

        <div className="text-12 lg:text-14 font-[400] bg-chipYellow rounded-full max-w-300 flex justify-center px-6 py-2 text-yellow mt-4">
          <h1>{landingPageData.whoCanJoin.title1}</h1>
        </div>

        {/* Category Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mt-8 lg:mt-20">
          {landingPageData.whoCanJoin.categories.map((category, index) => (
            <div
              key={index}
              className="bg-cardYellowBg max-w-[393px] rounded-3xl p-6 shadow-sm"
            >
              <div className="flex  items-center">
                <img
                  src={category.icon}
                  alt="Ph-imgs"
                  className="w-16 h-16 mr-4"
                />
                <div className="flex flex-col">
                  <h3 className="text-20 lg:text-24 font-[700] mt-4">
                    {category.title}
                  </h3>
                  <p className="text-16 font-[400] mt-2 text-textBlack">
                    {category.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhoCanJoin;
